export const NOT_YET_ADDED_TRANSLATIONS = {
	// Insert your key value pair here. Should be empty when pushed.
} as const;
